'use strict';
/*jslint debug: false */

angular.module('atex.art').config(['$httpProvider','$routeProvider', function($httpProvider, $routeProvider) {
    $httpProvider.interceptors.push('authInterceptor');
    /* jshint -W117 */
    $routeProvider.when('/', { controller: 'ArtContentListCtrl', templateUrl: 'views/list.html', resolve: ContentListController.resolves }).
                 when('/autosave/:id', { controller: 'ArtContentAutoSaveCtrl', templateUrl: 'views/autosave.html', resolve: ContentAutoSaveController.resolves }).
                 when('/edit/:id/:force?', { controller: 'ArtContentDetailsCtrl', templateUrl: 'views/detail.html', resolve: ArticleDetailController.editResolves }).
                 when('/editUsing/:id/:templateId/:force?', { controller: 'ArtContentDetailsCtrl', templateUrl: 'views/detail.html', resolve: ArticleDetailController.editUsingResolves }).
                 when('/new/:type', { controller: 'ArtContentDetailsCtrl', templateUrl: 'views/detail.html', resolve: ArticleDetailController.newResolves }).
                 when('/import', { controller: 'ArtImportCtrl', templateUrl: 'views/import.html' }).
                 when('/error', { controller: 'ArtErrorCtrl', templateUrl: 'views/error.html' }).
                 when('/about', { controller: 'ArtAboutCtrl', templateUrl: 'views/about.html' }).
                 when('/preview/:id', { controller: 'ArtContentPreviewCtrl', templateUrl: 'views/preview.html', resolve:ArticlePreviewController.resolves}).
                 otherwise({ redirectTo: '/' });

  }]).config(['$translateProvider', function ($translateProvider) {
    $translateProvider.useLoader('ArtLocalizationLoaderService', {
        prefix: 'locale/locale-',
        suffix: '.json'
    });
    $translateProvider.registerAvailableLanguageKeys(['en', 'it', 'de', 'nl', 'sv', 'es', 'dk', 'no', 'vi', 'tr'], {
        'en_*': 'en',
        'it_*': 'it',
        'de_*': 'de',
        'nl_*': 'nl',
        'sv_*': 'sv',
        'es_*': 'es',
        'dk_*': 'dk',
        'no_*': 'no',
        'vi_*': 'vi',
        'tr-*': 'tr',

        '*':'en'
    });
    $translateProvider.useSanitizeValueStrategy(null);
    }])
  .run(function($rootScope, Application, AuthenticationService, AuthenticationDialog, $location, ArtLocalizationService,
                $route, $window, ApplicationConfigurationService, $q) {

  $rootScope.$on('$routeChangeError', function(event, current, previous, rejection) {
    Application.currentErrorInfo = { error: rejection };
    $location.path(rejection.path || '/error');
  });

  var username;
  var authToken;


  $rootScope.$on('artRequestSignoff', function(event, currentUser, requestUsername) {
     var error = atex.onecms.error.Error({
          origin: 'Contributor Tool Single signon',
          type: 'loginConflict',
          severity: atex.onecms.error.severities.NORMAL,
          cause: "You are trying to sign on as " + requestUsername + " but you currently signed on as " + currentUser.username + ". Please sign off and try again"
     });
     Application.currentErrorInfo = { error: error };
     username = authToken = undefined;
     $location.path('/error');
  });

  // this must be called early on, before any request that may trigger the authentication dialog.
  $rootScope.$on('onecms:authenticationRequest', function(event, currentUser) {
    var modal;

     if (username !== undefined && authToken !== undefined) {
       if(currentUser !== undefined && currentUser.username !== undefined && currentUser.username !== username) {
         //This should not happen, but ...
         $rootScope.$broadcast('artRequestSignoff', currentUser, username);
       } else {
         AuthenticationService.loginByToken(username, authToken).then(function() {
           // WORKROUND: loginByToken does not initalise principalId in currentUser
           AuthenticationService.verifyLoggedIn().then(function(tokenData) {
             Application.currentUser.principalId = tokenData.userId;
             AuthenticationService.confirmAuthenticationRequest();
           });
         }, function() {
           console.log('ERROR: Login token not valid. This shouldn\'t happen. ಠ_ಠ');
           authToken = undefined;
         }).finally(function() {
           if (authToken === undefined) {
             // Single sign on failed ask the user
             $rootScope.$broadcast('onecms:authenticationRequest', undefined);
           } else {
             username = authToken = undefined;
           }
         });
       }
     } else {
       if (currentUser !== undefined && currentUser.username !== undefined) {
         username = currentUser.username;
       }

       modal = AuthenticationDialog.create({username: username});

       modal.whenAuthenticated().then(function () {
         AuthenticationService.confirmAuthenticationRequest();
         AuthenticationService.getCurrentUser().then(function(currentUser) {
           //Login Event
           $window.atex.analytics('set', 'userId', currentUser.principalId);
           $window.atex.analytics('set', 'userName', currentUser.username);
           $window.atex.analytics('event', { e: 'login' });
         });
       }, function () {
         AuthenticationService.cancelAuthenticationRequest();
       }).finally(function() {
           username = undefined;
       });
     }
  });

  $rootScope.$on('artInitApp', function () {

     ApplicationConfigurationService.getConfigurationFor([ 'statistics' ]).then(function(data) {
       AuthenticationService.getCurrentUser().then(function(currentUser) {
         if (!data) {
           console.error("No statistics server configuration found!");
           return;
         }

         //Login Event
         $window.atex.analytics('set', 'userId', currentUser.principalId);
         $window.atex.analytics('set', 'userName', currentUser.username);
         $window.atex.analytics('create', data.account);
         $window.atex.analytics('set', 'enabled', data.enabled);
         $window.atex.analytics('set', 'url', data.url);
         $window.atex.analytics('set', 'applicationName', data.applicationName);
         $window.atex.analytics('event', { e: 'access' });
       });
     });

    // set localization translations.
    ArtLocalizationService.init();
  });

  function logoutUser(currentUser, requestUsername) {
    console.info("Single Sign On: Sign off '" + currentUser.username + "' sign on '" + requestUsername + "'");
    Application.reset();

    localStorage.removeItem('act.user.associatedSites');
    localStorage.removeItem('act.user.taxonomyIds');

    return atex.GenericStore(atex.act.AngularUtils.applyingQ($q, $rootScope)).getInternals().clearAndInitializeDatabase();
  }

  var params = $location.search();
  if ("username" in params && "token" in params) {
    username = params.username;
    delete params.username;

    authToken = params.token;
    delete params.token;
    $location.search(params); //remove sign on parameters

    if(username !== undefined) {
      if(Application.currentUser !== undefined && Application.currentUser.username !== undefined && Application.currentUser.username !== username) {
        return logoutUser(Application.currentUser, username).then( function () {
          $rootScope.$broadcast('artInitApp');
        });
      }
    }
  }

  $rootScope.$broadcast('artInitApp');

});

angular.module('atex.art').factory('DamNotificationService',['ArtNotificationService', function(foo){
  return foo;
}]);

angular.module('atex.art').factory('authInterceptor', function($q, Application, $injector) {
  // Same mapping as onecms-lib in order to correctly use callWithAuthentication
  var HTTPCodeMapping = {
    401: atex.onecms.error.types.AUTHENTICATION_FAILED,
    403: atex.onecms.error.types.PERMISSION_DENIED,
    404: atex.onecms.error.types.NOT_FOUND,
    409: atex.onecms.error.types.CONFLICT,
    500: atex.onecms.error.types.SERVER_ERROR
  };

  var ArtLayoutService;

  return {
    'request' : function(config) {
      config.headers = config.headers || {};
      var str = config.url;
      if ( str === undefined || ( str !== undefined && str.indexOf('localapp') === -1 )) {
        config.headers['X-Auth-Token'] = Application.currentUser.token;

        if ( str && str.indexOf('layout/handj') !== -1 ) {
          if (!ArtLayoutService) {
            ArtLayoutService = $injector.get("ArtLayoutService");
          }
          if (ArtLayoutService) {
            ArtLayoutService.getAuthDetails(config.headers);
          }
        }
      } else {
        config.headers = {};
      }
      return config || $q.when(config);
    },
    'response': function(response) {
      if ( response.headers && response.config && response.config.url && response.config.url.indexOf('layout/handj') !== -1 ) {
        var authLocation = response.headers("X-Auth-Location");
        var authSession = response.headers("X-Auth-Session");

        if (authLocation || authSession) {
          if (!ArtLayoutService) {
            ArtLayoutService = $injector.get("ArtLayoutService");
          }
          if (ArtLayoutService) {
            ArtLayoutService.setAuthDetails(response.headers);
          }
        }
      }

      // do something on success
      return response;
    },
    'responseError': function(rejection) {
      rejection.type = HTTPCodeMapping[rejection.status];
      return $q.reject(rejection);
    }
  };
});

angular.module('atex.art').filter('limitHtml', function() {
  return function(text, limit, postfix) {
    var changedString = String(text).replace(/(<\/a>|<a[^>]+>)/gm, '');
    return changedString.length <= limit ? changedString : changedString.substr(0, limit - 1) + postfix;
  };
});

jQuery.event.special.touchstart = {
  setup: function( _, ns, handle ) {
    this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
  }
};
jQuery.event.special.touchmove = {
  setup: function( _, ns, handle ) {
    this.addEventListener('touchmove', handle, { passive: !ns.includes('noPreventDefault') });
  }
};